var map = {
	"./delete.mp3": "56c0",
	"./delete.ogg": "66b4",
	"./down.mp3": "1f90",
	"./down.ogg": "94ec",
	"./logo.png": "cf05",
	"./noaction.mp3": "bbe8",
	"./noaction.ogg": "db89",
	"./redo.mp3": "5fdd",
	"./redo.ogg": "c555",
	"./undo.mp3": "7660",
	"./undo.ogg": "47b3",
	"./up.mp3": "280f",
	"./up.ogg": "506b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";